import React from 'react';
import {Grid, Row, Col, Tabs, Tab} from 'react-bootstrap';
import {connect} from 'react-redux';
import MessagesList from './messages-list';
import PageTitle from '../../common/page-title';
import InlineCKEditor from '../../common/editor/inline-editor';
import {getMessages, getSentMessages} from '../../../actions/messages';
import {loadPageContent} from '../../../actions/content';

import './styles.css';
import {MESSAGE_RECEIVED, MESSAGE_SENT} from '../../../data/messageTypes';

class MyMessages extends React.Component {
  pageSlug = 'my-messages';

  state = {
    showRead: true,
    showUnread: true,
    tab: 'received'
  };

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getMessages());
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  onFilterChanged = (filter, value) => {
    this.setState({[filter]: value}, () => {
      const {showRead, showUnread} = this.state;
      let read;

      if (!showRead) {
        if (showUnread) {
          read = 0;
        }
      } else if (!showUnread) {
        read = 1;
      }

      this.props.dispatch(getMessages(read));
    });
  };
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  handleTabSelect = (tab) => {
    const {dispatch} = this.props;

    if (tab === MESSAGE_SENT) {
      dispatch(getSentMessages());
    } else {
      dispatch(getMessages());
    }

    this.setState({tab});
  };

  render() {
    const {
      messages, fetching, fetched, contents, sentFetching, sentFetched, sentMessages
    } = this.props;

    const {
      showRead, showUnread, tab
    } = this.state;

    return (
      <Grid bsClass="container" fluid className="my-messages">
        <Row>
          <Col lg={12}>
            <PageTitle>
              My messages
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={contents[`${this.pageSlug}_content_text`]}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Tabs activeKey={tab} onSelect={this.handleTabSelect} id="myMessagesTab">
              <Tab eventKey={MESSAGE_RECEIVED} title="My messages">
                <MessagesList
                  messages={messages}
                  fetching={fetching}
                  fetched={fetched}
                  showRead={showRead}
                  showUnread={showUnread}
                  onFilterChanged={this.onFilterChanged}
                  messageType={MESSAGE_RECEIVED}
                />
              </Tab>
              <Tab eventKey={MESSAGE_SENT} title="My sent messages">
                <MessagesList
                  messages={sentMessages}
                  fetching={sentFetching}
                  fetched={sentFetched}
                  showRead={showRead}
                  showUnread={showUnread}
                  onFilterChanged={this.onFilterChanged}
                  messageType={MESSAGE_SENT}
                />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  messages: state.messages.messages,
  sentMessages: state.messages.sentMessages,
  fetched: state.messages.fetched,
  fetching: state.messages.fetching,
  sentFetching: state.messages.sentFetching,
  sentFetched: state.messages.sentFetched,
  contents: state.content.list
});

export default connect(mapStateToProps)(MyMessages);



// WEBPACK FOOTER //
// ./src/components/team/my-messages/index.jsx